/* Filters out undefined and null */
export const isNonNil = <T extends unknown>(item: T | undefined | null): item is T =>
  typeof item !== "undefined" && item !== null;
